//people reducer types
export const LOADING_DAHSBOARD= 'LOADING_DASHBAORAD'
export const LOAD_DASHBOARD = 'LOAD_DASHBOARD'
export const FETCH_DASHBOARD_REQUEST= 'FETCH_DASHBOARD_REQUEST'
export const FETCH_DASHBOARD_REQUEST_SUCCESS = 'FETCH_DASHBOARD_REQUEST_SUCCESS'


